export default "__VITE_ASSET__58259eed__"